import { BaseService } from 'src/app/shared/services/base-service.service';
import {  Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrentUserDto } from '../../models/current-user.model';
import { CryptoService } from '../crypto';
@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  public isUserLogin$: Subject<boolean> = new Subject<boolean>();
  constructor(private http: HttpClient,
    private cryptoService: CryptoService
  ) {
    super();
  }
  
  currentUserInfo: CurrentUserDto = {};
  initiateSSO(): void {
    this.http.get<any>(`/api/Auth/GetIAMUrl`).subscribe(
      (response) => {
        // Assuming ApiResponse<string> contains a 'url' property
        if (response) {
          // Redirect to the obtained URL
          window.location.href=response.value.value;
        } else {
          // Handle case where URL is not available in the response
          console.error('URL not found in response');
        }
      },
      (error) => {
        // Handle error if the HTTP request fails
        console.error('Error fetching URL:', error);
        // You might want to handle this error in a suitable way for your application
        // For example, display an error message to the user
      }
    );
  }
  IsAuthorize(roles: Array<string>) {
    
    
    let userInfoLS = localStorage.getItem('userInfo');
    // let userInfoLS = localStorage.getItem('token');
    if (userInfoLS) {
      let decUserInfo = this.cryptoService.decryptUsingAES256(userInfoLS);
      let userInfo: CurrentUserDto = JSON.parse(decUserInfo);

      for (let i = 0; i < roles?.length; i++) {
        if (userInfo?.roles?.includes(roles[i])) {
          return true;
        }
      }
      return false;
    }
    return false;
  }
}
